import styled from 'styled-components';
import { TableContent } from 'cdk-radial';

const StyledTableContentWrapper = styled(TableContent)``;

export default StyledTableContentWrapper;
